var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import NavigationPrompt from 'react-router-navigation-prompt';
import { ButtonVariant } from '../Button';
import { StyledDialogButton } from '../Dialog/StyledDialogButton';
import { StyledPrompt } from './StyledPrompt';
var StyledNavigationPrompt = /** @class */ (function (_super) {
    __extends(StyledNavigationPrompt, _super);
    function StyledNavigationPrompt() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSave = function (onConfirm, onCancel) { return function () {
            if (_this.props.onSave) {
                _this.props.onSave();
                onCancel();
            }
        }; };
        _this.handleCancel = function (navigationPromptCancel) { return function () {
            navigationPromptCancel();
            if (_this.props.onCancel) {
                _this.props.onCancel();
            }
        }; };
        _this.handleConfirm = function (navigationPromptConfirm) { return function () {
            navigationPromptConfirm();
            if (_this.props.onConfirm) {
                _this.props.onConfirm();
            }
        }; };
        return _this;
    }
    StyledNavigationPrompt.prototype.render = function () {
        var _this = this;
        if (!this.props.when)
            return null;
        return (React.createElement(NavigationPrompt, __assign({}, this.props, { renderIfNotActive: false }), function (_a) {
            var onConfirm = _a.onConfirm, onCancel = _a.onCancel;
            return (React.createElement(StyledPrompt, { open: true, title: 'Save changes?', onCancel: onCancel, actions: [
                    React.createElement(StyledDialogButton, { title: 'Cancel', key: 'keep-user-file-changes', variant: ButtonVariant.light, onClick: _this.handleCancel(onCancel), testId: 'cancel' }, "Cancel"),
                    React.createElement(StyledDialogButton, { title: 'Discard', key: 'discard-user-file-changes', onClick: _this.handleConfirm(onConfirm), testId: 'discard' }, "Discard"),
                    _this.props.onSave && (React.createElement(StyledDialogButton, { title: 'Save', key: 'save-user-file-changes', onClick: _this.handleSave(onConfirm, onCancel), testId: 'save' }, "Save"))
                ] }, "Unsaved changes will be lost."));
        }));
    };
    return StyledNavigationPrompt;
}(React.Component));
export { StyledNavigationPrompt };
